'use es6';

import tinymce from 'tinymce';
import PropTypes from 'prop-types';
import { Component } from 'react';
import FormatSelect from 'rich-text-lib/components/formatting/FormatSelect';
import { trackInteraction } from '../../utils/usageTracking';
import { CHANGE_BLOCK_FORMAT } from '../../constants/usageTracking';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TinyMceFormatSelect extends Component {
  constructor(props) {
    super(props);
    this.handleFormatChange = event => {
      const {
        editor,
        value
      } = this.props;
      const format = event.target.value;
      const applyFormat = () => {
        editor.execCommand('mceToggleFormat', false, format);
      };
      editor.undoManager.transact(() => {
        if (value === 'blockquote') {
          editor.formatter.remove('blockquote');
        }
        if (format === 'blockquote') {
          editor.execCommand('hsblockquote');
        } else if (value === 'pre') {
          editor.execCommand('hscodeblock', false, {
            format,
            applyFormatDefault: applyFormat
          });
        } else {
          applyFormat();
        }
        if (format === 'pre' || format === 'blockquote') {
          editor.execCommand('hsInsertNewline', false, {
            target: editor.dom.getParent(editor.selection.getRng().startContainer, format)
          });
        }
      });
      trackInteraction(editor, 'tinymceFormatting', CHANGE_BLOCK_FORMAT, {
        method: 'button',
        value: format
      });
    };
    this.formats = props.formats;
  }
  render() {
    const {
      value
    } = this.props;
    return /*#__PURE__*/_jsx(FormatSelect, {
      use: "on-dark",
      formats: this.formats,
      value: value,
      onChange: this.handleFormatChange,
      dropdownClassName: "mce-format-select"
    });
  }
}
TinyMceFormatSelect.propTypes = {
  editor: PropTypes.instanceOf(tinymce.Editor).isRequired,
  formats: PropTypes.array.isRequired,
  value: PropTypes.string
};